import * as React from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import pagentlogo from "../../assets/pagent-logo-text.png"
import {
    storeAccessToken, storeToken, storeUserInfo,
} from "../../utils/auth-token-utils/cookie";
import Spinner from "../../components/Spinner";
import routePaths from "../../router/route-paths";
import { showToast } from "../../store/slices/common";
import { login } from "../../http/auth";
import CustomTextField from "../../components/Textfield";
import { loginUser } from "../../comet-chat";
import pagentlogoIcon from "../../assets/pagent-logo-icon.png";
import { ToastContainer } from "react-toastify";

export default function SignIn() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [loading, setLoading] = React.useState(false);

    // Full admins sign in with their email; restricted admin accounts created
    // from the Admin Accounts page sign in with their username.
    const validateForm = (email, password) => {
        if (!email.trim()) {
            dispatch(showToast({ color: "error", msg: "Username or email is required" }));

            return false
        }
        if (!password.trim()) {
            // handleToast("Password is required", toast, toastId, setToastId)
            dispatch(showToast({ color: "error", msg: "Password is required" }));

            return false
        }
        return true;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const email = data.get("email");
        const password = data.get("password");

        if (!validateForm(email, password)) {
            return
        }

        try {
            setLoading(true);

            const response = await login({ email: email.trim(), password });
            const resData = response.data.data;

            if (resData) {
                await loginUser(resData, dispatch);

                storeAccessToken(resData.token);
                // A temporary password (issued by a full admin) must be replaced
                // before the account can use anything else.
                const landing = resData.profile?.mustChangePassword
                    ? routePaths.CHANGE_PASSWORD
                    : routePaths.DASHBOARD;
                navigate(landing, { state: { token: resData.token } });

                const remember = data.get("remember");

                // store token in case of remember me is checked
                if (remember) {
                    storeToken(resData.token);
                    storeUserInfo(resData);
                }
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    };

    return (<Container component="main" maxWidth="xs">
        <CssBaseline />
        {loading && <Spinner />}
        <Box
            sx={{
                paddingTop: 8, display: "flex", flexDirection: "column", alignItems: "center",
            }}
        >
            <Box sx={{
                display: 'flex', alignItems: 'center',
                margin: '0 auto 20px 0',
            }}>
                <img src={pagentlogoIcon} alt="Pagent Logo"
                    style={{ width: 'auto', height: '50px' }} />
                <img src={pagentlogo} alt="Pagent Logo" style={{ width: 'auto', height: '40px', position: 'relative', top: '5px', left: '5px' }} />
            </Box>
            <Typography
                component="h1"
                variant="h3"
                sx={{
                    margin: '0 0 20px',
                    textAlign: 'left',
                    width: "390px",
                    color: "#142C5C",
                    fontSize: '30px',
                    fontWeight: 700,
                    lineHeight: '36px'
                }}
            >
                Sign In
            </Typography>

            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                <CustomTextField
                    required
                    fullWidth
                    id="email"
                    placeholder="Username or Email"
                    name="email"
                    autoComplete="username"
                    autoFocus

                    style={{ marginBottom: "20px" }}
                />
                <CustomTextField
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    placeholder="Password"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                    style={{ marginBottom: "10px" }}
                />

                {<FormControlLabel
                    name="remember"
                    control={<Checkbox
                        value="remember"
                        sx={{ color: "#142C5C", "& svg": { fill: "#142C5C" } }}
                    />}
                    label="Remember me"
                />}
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{
                        mt: 3,
                        mb: 2,
                        background: "#142C5C",
                        borderRadius: "61px",
                        height: '60px',
                        "&:hover": { background: "#142C5C" },
                    }}
                >
                    Sign In
                </Button>
            </Box>
            <ToastContainer />
        </Box>
    </Container>);
}



